export default __webpack_public_path__ + "static/media/iconsLeftline.6467e157.svg";